import {FunctionComponent, useMemo} from 'react';
import {compareDesc} from 'date-fns';
import environment from '@/environment';
import {Document} from '@/interfaces/document';
import DocumentListItem from './item';

interface ElementProps {
  documents: Document[];
  linksDisabled?: boolean;
  emptyResultMessage: string;
  onItemClick: () => void;
}

const DocumentList: FunctionComponent<ElementProps> = ({
  linksDisabled = false,
  documents,
  emptyResultMessage,
  onItemClick,
}) => {
  const sortedDocuments = useMemo(() => {
    return documents.sort((documentA, documentB) => compareDesc(documentA.createdAt, documentB.createdAt));
  }, [documents]);

  return (
    <>
      {documents.length > 0 ? (
        <ol className="flex flex-col gap-1">
          {sortedDocuments.map((document, index) => (
            <DocumentListItem
              showVersion={environment.DEBUG}
              linksDisabled={linksDisabled}
              document={document}
              key={index}
              onClick={onItemClick}
            />
          ))}
        </ol>
      ) : (
        <p className="px-6 text-base font-medium text-charcoal">{emptyResultMessage}</p>
      )}
    </>
  );
};

export default DocumentList;
